module.exports = __webpack_public_path__ + "img/IMG_6442 1.4f27718f.png";